import { useFlag } from '@calendly/feature-check-react'
import { useQueryParams } from '@calendly/hooks'

/**
 * Centralized gate for V1 meetings realtime features (list + right-rail polling).
 * True when the feature flag is on, unless the URL has ?live=0 (opt-out for testing).
 */
export function useMeetingsRealtimeFeaturesEnabled(): boolean {
  const hasFlag = useFlag('meetings_recaps_realtime_feature')
  const queryParams = useQueryParams()
  return !!(hasFlag && queryParams?.live !== '0')
}
